import type { AnalyticsFiltersState } from "./types";

export const DEFAULT_PAGE_SIZE = 10;

/** Page size when fetching all rows for CSV export (fewer HTTP round-trips than UI page size). */
export const ANALYTICS_TABLE_EXPORT_PAGE_SIZE = 500;

export const toInputDate = (value: string | null): string => value ?? "";

export const fromInputDate = (value: string) => (value ? value : null);

export const formatNumber = (value: number | null | undefined) =>
  typeof value === "number" && Number.isFinite(value)
    ? value.toLocaleString()
    : "—";

export const formatPercent = (
  value: number | null | undefined,
  fractionDigits = 1,
) =>
  typeof value === "number" && Number.isFinite(value)
    ? `${value.toFixed(fractionDigits)}%`
    : "—";

export const buildFiltersKey = (filters: AnalyticsFiltersState) =>
  [
    filters.clienteIntermedioId ?? "all",
    filters.clienteFinalId ?? "all",
    filters.programaId ?? "all",
    filters.actividadId ?? "all",
    filters.dateRange.from ?? "null",
    filters.dateRange.to ?? "null",
  ].join("|");
